import { render, staticRenderFns } from "./permission-button.vue?vue&type=template&id=b68b1c54&scoped=true&"
import script from "./permission-button.vue?vue&type=script&lang=js&"
export * from "./permission-button.vue?vue&type=script&lang=js&"
import style0 from "./permission-button.vue?vue&type=style&index=0&id=b68b1c54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68b1c54",
  null
  
)

export default component.exports